export const TTL_IN_SECONDS = {
  TWO_SECONDS: 2,
  TWO_MINUTES: 120,
  FIVE_MINUTES: 300,
  FIFTEEN_MINUTES: 900,
  ONE_HOUR: 3600,
  ONE_DAY: 3600 * 24,
  ONE_YEAR: 3600 * 24 * 365
} as const;

export const TTL_IN_MILLISECONDS = {
  ONE_SECOND: 1000,
  THREE_QUARTERS_OF_A_SECOND: 750,
  TWO_SECONDS: 2000,
  FOUR_SECONDS: 4000
} as const;

// The space between the content and top of the page when the content should become sticky
export const STICKY_MAIN_CONTENT_OFFSET = '5.2rem';

export enum SupportedExperiments {
  DisableAdviceCueBlock = 'disable-advice-cue-block',
  EnableStoreEmployeeFlow = 'enable-store-employee-flow',
  EnableSecondChanceMicrofrontend = 'enable-second-chance-microfrontend',
  EnableArticlePanel = 'enable-article-panel',
  FakePersonalDiscount = 'fake-personal-discount',
  EnableMandyProductPlusPromotion = 'enable-mandy-product-plus-journey'
}

export const secondChanceExcludedSections = [
  'ALTERNATIVES',
  'INSURANCE_AND_SUBSCRIPTION',
  'MANUFACTURERS_SPECIFICATIONS'
];

export const missedChanceExcludedSections = [
  'CONFIGURATOR',
  'PRODUCT_INFORMATION',
  'REVIEWS',
  'ACCESSORY_CATEGORIES',
  'RULE_BASED_PROPOSITIONS',
  'SPECIFICATIONS',
  'ORDER_BLOCK_SUMMARY',
  ...secondChanceExcludedSections
];
